<template>
  <div>
    <el-form-item label="Environment">
      <el-select v-model="form.env" @change="change">
        <el-option value="development" label="Development" />
        <el-option value="staging" label="Staging" />
        <el-option value="production" label="Production" />
      </el-select>
    </el-form-item>

    <el-form-item label="Database">
      <el-select v-model="form.db" disabled>
        <el-option v-if="form.db.match(/maria/)" :value="form.db" label="MariaDB (embedded)" />
        <el-option v-else :value="form.db" label="MySQL (embedded)" />
      </el-select>

      <el-button icon="mdi mdi-open-in-new" @click.prevent="dbadmin">phpMyAdmin</el-button>
    </el-form-item>
  </div>
</template>

<script>
import config from '../../../mixins/config'
export default {
  mixins: [config],
  methods: {
    dbadmin () {
      window.open(this.applicationUrl(this.form) + '/runstack-dbadmin/', '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-button {
    margin-top: 5px;
    margin-bottom: 5px;
  }
</style>
